import { AiOutlineCodeSandbox } from "react-icons/ai";
import { AiOutlineContacts } from "react-icons/ai";
import { AiOutlineHome } from "react-icons/ai";
import { BsPerson } from "react-icons/bs";

export const sections = [
  {
    label: "Home",
    url: "/",
    icon: AiOutlineHome,
  },
  {
    label: "Sobre",
    url: "/about",
    icon: BsPerson,
  },

  {
    label: "Projetos",
    url: "/projects",
    icon: AiOutlineCodeSandbox,
  },
  {
    label: "Contato",
    url: "/contact",
    icon: AiOutlineContacts,
  },
];
